import { render, staticRenderFns } from "./manager.layout.vue?vue&type=template&id=39b234c8&lang=pug"
import script from "./manager.layout.vue?vue&type=script&lang=ts"
export * from "./manager.layout.vue?vue&type=script&lang=ts"
import style0 from "./manager.layout.vue?vue&type=style&index=0&id=39b234c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports